import { ButtonHomeNotHoverV2, ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import React, { useEffect, useState } from 'react';
import { MdAttachEmail } from 'react-icons/md';
import { ConfigProvider, Input, message, Modal } from 'antd';
import Colors from 'enums/Colors';
import logoHumane from '../../../pages/acessoExclusivo/pages/assets/logoHumane.svg';
import keycloak from 'core/config/keycloak';
import { CertificacoesService } from 'core/http/service/Certificacoes.service';
import { UsuariosCertificadosService } from 'core/http/service/UsuariosCertificados.service';

interface IModalCertificadoEnviarPorEmailProps {
    codigoCertificado: number;
    stylesButton?: React.CSSProperties;
}
const servicesCertificacoes = new CertificacoesService();
const usuariosCertificadosService = new UsuariosCertificadosService();

export const ModalCertificadoEnviarPorEmail = ({ codigoCertificado, stylesButton }: IModalCertificadoEnviarPorEmailProps) => {
        const [messageApi, contextHolder] = message.useMessage();
    
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState<string>('');
    const [openModal, setOpenModal] = useState(false);

    const handleSendEmailCertificado = async (certificadoCodigo: number, email: string) => {
        try {
            setLoading(true);
            // Garantir que o usuário está associado ao certificado antes de enviar por e-mail
            try {
                console.log('Associando usuário ao certificado antes de enviar e-mail...');
                await usuariosCertificadosService.associarUser(certificadoCodigo, false);
            } catch (error) {
                // Ignora erros de associação (registro pode já existir)
                console.warn('Erro ao associar usuário (pode já estar associado)', error);
            }
            
            const { status } = await servicesCertificacoes.sendEmailCertificado(certificadoCodigo, email);
            if (status === 200) {
                messageApi.success('E-mail enviado com sucesso!');
            }
        } catch (error) {
            console.log('🚀 ~ handleSendEmailCertificado ~ error:', error);
            messageApi.error('Erro ao enviar e-mail. Tente novamente.');
        } finally {
            setLoading(false);
            setOpenModal(false);
        }
    };

    useEffect(() => {
        if (keycloak.authenticated) {
            const emailUser = keycloak.tokenParsed?.email;

            if (emailUser) {
                setEmail(emailUser);
            }
        }
    }, []);

    return (
        <>
        {contextHolder}
            <ButtonHomeV2
                style={{
                    minHeight: '60px',
                    gap: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ...stylesButton, 
                }}
                onClick={() => setOpenModal(true)}
            >
                {loading ? 'Carregando...' : 'Enviar'} <MdAttachEmail size={24} style={{ position: 'relative', top: '4px' }} />
            </ButtonHomeV2>

            {openModal && (
                <Modal
                    confirmLoading={loading}
                    onCancel={() => setOpenModal(false)}
                    width={700}
                    open={openModal}
                    closeIcon={false}
                    maskClosable={false}
                    footer
                >
                    <ConfigProvider
                        input={{
                            style: {
                                height: 72,
                                fontSize: 22,
                            },
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '28px 66px' }}>
                            <img src={logoHumane} alt="logo-humane" style={{ width: '176px' }} />

                            <p style={{ fontSize: '18px' }}>{loading && 'Enviando e-mail, aguarde...'}</p>

                            <p>Confirme seu e-mail abaixo para envio do certificado:</p>
                            <Input placeholder="Digite o e-mail." value={email} onChange={e => setEmail(e.target.value)} size={'large'} />

                            <ButtonHomeV2
                                style={{
                                    minHeight: '60px',
                                    gap: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '20px',
                                    justifyContent: 'center',
                                }}
                                onClick={() => handleSendEmailCertificado(codigoCertificado, email)}
                            >
                                {loading ? 'Carregando...' : 'Enviar'}{' '}
                                <MdAttachEmail size={24} style={{ position: 'relative', top: '4px' }} />
                            </ButtonHomeV2>
                            <ButtonHomeNotHoverV2
                                style={{
                                    minHeight: '60px',
                                    gap: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '20px',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.White,
                                    color: Colors.Blue,
                                }}
                                onClick={() => setOpenModal(false)}
                            >
                                Fechar
                            </ButtonHomeNotHoverV2>
                        </div>
                    </ConfigProvider>
                </Modal>
            )}
        </>
    );
};
